module.exports = __webpack_public_path__ + "img/50_38.5646503a.png";